export enum ConveyorLenghtType {
  long,
  short,
  magnet,
  wind
}
